import { useState, useRef } from "react";
import emailjs from "emailjs-com";
import React from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box } from "@mui/material";

const initialState = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, phone, subject, message }, setState] = useState(initialState);
  const form = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, phone, subject, message);

    emailjs
      .sendForm(
        "service_6ywi4fj", // Replace with your EmailJS service ID
        "template_0upo7an", // Replace with your EmailJS template ID
        form.current,
        "IK0d6uZg7lH8It35o"   // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          toast.success("Message sent successfully!");
        },
        (error) => {
          console.log(error.text);
          toast.error("An error occurred, please try again.");
        }
      );
  };

  return (
    <div style={{marginBottom:'-5rem'}}>
      <ToastContainer />
       <Box  >
        <div id="contact" >
          <div className="container">
            <div className="col-md-8">
               <Box sx={{ padding: {xs: 4, sm: 4,  md: 4,} }}>
               <div className="row" >
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we will
                    get back to you as soon as possible.
                  </p>
                </div>
                <form ref={form} name="sentMessage" validate onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6" >
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          required
                          value={name}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          value={email}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="number"
                          id="phone"
                          name="phone"
                          className="form-control"
                          placeholder="Phone Number"
                          required
                          value={phone}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="subject"
                          name="subject"
                          className="form-control"
                          placeholder="Subject"
                          required
                          value={subject}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      value={message}
                      onChange={handleChange}
                      style={{width:"99.5%"}}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                </form>
              </div>
               </Box>
            </div>
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <h3>Contact Info</h3>
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> 281, Indira Vihar, TP
                    Nagar, Korba, CG 495677
                  </span>
                  {props.data ? props.data.address : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> +91-9893799440, 9399497970
                  </span>{" "}
                  {props.data ? props.data.phone : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i>{" "}
                    sales.elitekorba@gmail.com / elite22.krb@gmail.com
                  </span>{" "}
                  {props.data ? props.data.email : "loading"}
                </p>
              </div>
            </div>
          </div>
        </div>
       </Box>
    </div>
  );
};
